import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { pullSingle, pullMulti } from 'features/pullsSlice.js';
import ApexCharts from 'react-apexcharts';

// Chakra imports
import { Box, Button, Flex, Text, Select, SimpleGrid, useColorModeValue } from "@chakra-ui/react";
// Custom ui components
import Card from "components/card/Card.js";
import PieChart from "components/charts/PieChart";
import { pieChartData, pieChartOptions } from "variables/charts";
import { VSeparator } from "components/separator/Separator";

export default function Conversion(props) {
  const { ...rest } = props;
  const dispatch = useDispatch()
  const distributionSSR = useSelector(state => state.pulls.distributionSSR);
  const distributionSR = useSelector(state => state.pulls.distributionSR);
  const distributionR = useSelector(state => state.pulls.distributionR);
  const countSSR = useSelector(state => state.pulls.countSSR);
  const countSR = useSelector(state => state.pulls.countSR);
  const countR = useSelector(state => state.pulls.countR);


  // Chakra Color Mode
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const cardColor = useColorModeValue("white", "navy.700");
  const cardShadow = useColorModeValue(
    "0px 18px 40px rgba(112, 144, 176, 0.12)",
    "unset"
  );

  return (
    <Card p='20px' align='center' direction='column' w='100%' h='100%' {...rest}>
      <Flex
        px={{ base: "0px", "2xl": "10px" }}
        justifyContent='space-between'
        alignItems='center'
        w='100%'
        mb='8px'>
        <Text color={textColor} fontSize='md' fontWeight='600' mt='4px'>
          Rarity Distribution
        </Text>
      </Flex>

      <PieChart
        h='100%'
        w='100%'
        chartData={[Math.max(0.3,countSSR), Math.max(10,countSR), Math.max(89.7,countR)]}
        chartOptions={pieChartOptions}
      />
      <Card
        bg={cardColor}
        flexDirection='row'
        boxShadow={cardShadow}
        w='100%'
        p='15px'
        px='20px'
        mt='15px'
        mx='auto'>
        <Flex direction='column' py='5px'>
          <Flex align='center'>
            <Box h='8px' w='8px' bg='#F4A417' borderRadius='50%' me='4px' />
            <Box h='8px' w='8px' bg='#F4A417' borderRadius='50%' me='4px' />
            <Box h='8px' w='8px' bg='#F4A417' borderRadius='50%' me='4px' />
            <Box h='8px' w='8px' bg='#F4A417' borderRadius='50%' me='4px' />
            <Box h='8px' w='8px' bg='#F4A417' borderRadius='50%' me='4px' />
            <Text
              fontSize='xs'
              color='secondaryGray.600'
              fontWeight='700'
              mb='0px'>
              SSR
            </Text>
          </Flex>
          <Text fontSize='lg' color={textColor} fontWeight='700'>
            {distributionSSR} %
          </Text>
        </Flex>
        <VSeparator mx={{ base: "60px", xl: "60px", "2xl": "60px" }} />
        <Flex direction='column' py='5px' me='10px'>
          <Flex align='center'>
            <Box h='8px' w='8px' bg='#BD1EF4' borderRadius='50%' me='4px' />
            <Box h='8px' w='8px' bg='#BD1EF4' borderRadius='50%' me='4px' />
            <Box h='8px' w='8px' bg='#BD1EF4' borderRadius='50%' me='4px' />
            <Box h='8px' w='8px' bg='#BD1EF4' borderRadius='50%' me='4px' />
            <Text
              fontSize='xs'
              color='secondaryGray.600'
              fontWeight='700'
              mb='0px'>
              SR
            </Text>
          </Flex>
          <Text fontSize='lg' color={textColor} fontWeight='700'>
            {distributionSR} %
          </Text>
        </Flex>
        <VSeparator mx={{ base: "60px", xl: "60px", "2xl": "60px" }} />
        <Flex direction='column' py='5px' me='10px'>
          <Flex align='center'>
            <Box h='8px' w='8px' bg='#1E96F4' borderRadius='50%' me='4px' />
            <Box h='8px' w='8px' bg='#1E96F4' borderRadius='50%' me='4px' />
            <Box h='8px' w='8px' bg='#1E96F4' borderRadius='50%' me='4px' />
            <Text
              fontSize='xs'
              color='secondaryGray.600'
              fontWeight='700'
              mb='0px'>
              R
            </Text>
          </Flex>
          <Text fontSize='lg' color={textColor} fontWeight='700'>
            {distributionR} %
          </Text>
        </Flex>
      </Card>

      <SimpleGrid align='center' >
      <br/>
        <Text
          fontSize='xs'
          color='secondaryGray.600'
          fontWeight='700'
          mb='5px'>
          MAKE A
        </Text>
        <Button w='100%' onClick={() => dispatch(pullSingle())}>
          WISH
        </Button>
        <br/>
        <Button onClick={() => dispatch(pullMulti())}>
          WISH x10
        </Button>
      </SimpleGrid>

    </Card>
  );
}
